import { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import { useQuery } from '@tanstack/react-query';
import {
  // IconBuildingBank,
  // IconCreditCard,
  // IconWallet,
  IconQrcode,
  // IconCreditCardPay,
} from '@tabler/icons-react';
import moment from 'moment';
// import { toast } from 'react-hot-toast';
// import qs from 'qs';
// import * as Yup from 'yup';

// import { get } from 'network/api';

import BusinessName from './BusinessName';
import Typography from 'components/Typography';
import CardPaymentMethod from 'components/CardPaymentMethod';
import SectionSummaryOrderMobileProps from './SectionSummaryOrderMobile';
import PaymentResult from './PaymentResult';
import { DataDetailCheckout, SettingsProps } from '../types';

import { rupiah } from 'lib/currency';
// import LoadingMethod from './LoadingMethod';

// const phoneNumberSchema = Yup.string()
//   .required('Phone number is required')
//   .test(
//     'valid-phone-number',
//     'Phone number must be a valid Indonesian number',
//     (value) => {
//       if (!value) return false;
//       if (value.trim() === '+62') return false;
//       return /^(?:\+62|62|0)[2-9][0-9]{7,12}$/.test(value);
//     }
//   );

interface MethodProps {
  data: DataDetailCheckout;
  pickPayment: boolean;
  setPickPayment: (value: boolean) => void;
  settings: SettingsProps;
}

type PaymentResultData = {
  type: string | undefined;
  bank: string | undefined;
  va_number: string | undefined;
  account_name: string | undefined;
  qr_content: string | undefined;
  host_to_host_payment_info: {
    web_redirect_url: string | undefined;
  };
};

const Method: React.FC<MethodProps> = ({
  data,
  pickPayment,
  setPickPayment,
  settings,
}) => {
  // const location = useLocation();
  // const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  // const { id } = query as { id?: string };
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [dataPayment, setDataPayment] = useState<PaymentResultData | null>(
    null
  );

  const isPaymentStatusFailed = data?.payment?.status === 'FAILED';
  const isPaymentTypeCard = data?.payment?.string === 'cards';

  // const getDetailMethodPayment = async (id: string) => {
  //   return get(`/checkout/v1/payment-method?invoice_number=${id}`);
  // };

  // const { data: dataMethod, isLoading } = useQuery({
  //   queryKey: ['getDetailMethodPayment', id],
  //   queryFn: async () => {
  //     try {
  //       if (!id) throw new Error('ID is required');
  //       const response = await getDetailMethodPayment(id);
  //       return response;
  //     } catch (err) {
  //       const error = err as { detail: string };
  //       toast.error(error?.detail || 'An unexpected error occurred');
  //       throw err;
  //     }
  //   },
  //   retry: false,
  //   enabled: !!id,
  // });

  useEffect(() => {
    if (data.payment) {
      setPickPayment(true);
      setDataPayment({
        type: data.payment ? data?.payment?.string : '-',
        bank: data.payment ? data?.payment?.va?.bank : '-',
        va_number: data.payment ? data?.payment?.va?.va_number : '-',
        account_name: data.payment
          ? data?.payment?.va?.virtual_account_name
          : '-',
        qr_content: data.payment ? data?.payment?.qris?.qr_content : '-',
        host_to_host_payment_info: data.payment
          ? data.payment?.host_to_host_payment_info || {
              web_redirect_url: undefined,
            }
          : {
              web_redirect_url: undefined,
            },
      });
    }
  }, [data, setPickPayment]);

  // const handleOnSubmit = async (
  //   paymentType: ItemPayment | undefined,
  //   id: string
  // ) => {
  //   if (!paymentType) {
  //     toast.error('Payment type is not selected!');
  //     return;
  //   }

  //   if (paymentType.type === 'ewallet') {
  //     try {
  //       await phoneNumberSchema.validate(phoneNumber);
  //     } catch (error) {
  //       if (error instanceof Yup.ValidationError) {
  //         toast.error(error.message);
  //       }
  //       return;
  //     }
  //   }

  //   const payload = {
  //     type: paymentType.type ? paymentType.type : '',
  //     service_id: paymentType.service_id ? paymentType.service_id : '',
  //     customer_no: phoneNumber ? phoneNumber : '',
  //     payment_method_id: paymentType.id ? paymentType.id : 0,
  //   };

  //   setLoadingSubmit(true);
  //   await post(`/checkout/v1/payment-method?invoice_number=${id}`, payload)
  //     .then((res) => {
  //       const { data } = res;
  //       setDataPayment({
  //         type: data.type ? data?.type : '-',
  //         bank: data.bank_info ? data?.bank_info?.bank_name : '-',
  //         va_number: data.bank_info ? data?.bank_info?.account_number : '-',
  //         account_name: data.virtual_account_name
  //           ? data?.virtual_account_name
  //           : '-',
  //         qr_content: data.qr_content ? data?.qr_content : '-',
  //         host_to_host_payment_info: data.h2h_payment_info || {
  //           web_redirect_url: undefined,
  //         },
  //       });
  //       setPickPayment(true);
  //       setLoadingSubmit(false);

  //       if (data.h2h_payment_info.web_redirect_url) {
  //         if (data.h2h_payment_info.web_redirect_url.startsWith('http')) {
  //           window.open(data.h2h_payment_info.web_redirect_url, '_blank');
  //         } else {
  //           window.location.href = data.h2h_payment_info.web_redirect_url;
  //         }
  //       }
  //     })
  //     .catch((err) => {
  //       toast.error(err.detail);
  //       setLoadingSubmit(false);
  //     });
  // };

  const DEFAULT_DATA = {
    data: {
      qris: [
        {
          id: 0,
          code: '',
          name: '',
          icon: '',
          type: 'qris',
          service_id: '',
          host_to_host_payment_info: {
            web_redirect_url: '',
          },
        },
      ],
    },
  };

  // if (isLoading) {
  //   return <LoadingMethod />;
  // }

  return (
    <div className="pb-6 pt-8 px-4 lg:px-0">
      <BusinessName data={data} />
      <div className="my-8">
        <div className="mx-auto text-center">
          <Typography variant="body" className="font-medium">
            Pay Before{' '}
            {data?.payment_link_expiration
              ? moment(data?.payment_link_expiration).format(
                  'MMMM DD, YYYY [At] h:mm:ss A'
                )
              : '-'}
          </Typography>
          <h1
            className="lg:text-5xl text-4xl font-semibold mt-1.5 !leading-normal"
            style={{
              color: settings.button_color,
            }}
          >
            {data.total ? rupiah(data.total) : 'Rp -'}
          </h1>
          {isPaymentStatusFailed && isPaymentTypeCard ? (
            <div className="mt-4 rounded-lg border border-error-main bg-error-light p-4">
              <div className="text-sm text-red-900 text-center space-y-2">
                <div>
                  We&apos;re sorry, your credit card payment was not successful.
                </div>
                <div>
                  Please check your card details, ensure funds are available, or
                  try using a different payment method.
                </div>
                <div>You can retry your payment now.</div>
              </div>
            </div>
          ) : null}
        </div>

        <div className=" mt-3">
          {data.status && (
            <div className="mb-3 flex flex-row justify-end">
              <span
                className="inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium capitalize shadow-sm text-white"
                style={{
                  backgroundColor: settings.button_color,
                }}
              >
                {data.status ? data.status : '-'}
              </span>
            </div>
          )}
          {pickPayment ? (
            <div className="flex flex-col gap-1.5">
              <PaymentResult
                data={dataPayment}
                merchant={data.merchant.name}
                settings={settings}
              />
              <SectionSummaryOrderMobileProps data={data} settings={settings} />
            </div>
          ) : (
            <div className="flex flex-col gap-1.5">
              {/* <CardPaymentMethod
                dataImg={dataMethod?.data.va}
                name="BANK"
                type="VIRTUAL_ACCOUNT"
                icon={
                  <IconBuildingBank className="w-[22px] h-[22px] text-gray-800" />
                }
                isOpen={openIndex === 0}
                onToggle={() => setOpenIndex(openIndex === 0 ? null : 0)}
                settings={settings}
                setPickPayment={setPickPayment}
                setDataPayment={setDataPayment}
              />

              <CardPaymentMethod
                dataImg={dataMethod?.data.cards}
                name="CREDIT CARD"
                type="CARD"
                icon={
                  <IconCreditCard className="w-[22px] h-[22px] text-gray-800" />
                }
                isOpen={openIndex === 1}
                onToggle={() => setOpenIndex(openIndex === 1 ? null : 1)}
                settings={settings}
                setPickPayment={setPickPayment}
                setDataPayment={setDataPayment}
              />

              <CardPaymentMethod
                dataImg={dataMethod?.data.ewallet}
                name="E-WALLET"
                type="E-WALLET"
                icon={
                  <IconWallet className="w-[22px] h-[22px] text-gray-800" />
                }
                isOpen={openIndex === 2}
                onToggle={() => setOpenIndex(openIndex === 2 ? null : 2)}
                settings={settings}
                setPickPayment={setPickPayment}
                setDataPayment={setDataPayment}
              />

              <CardPaymentMethod
                dataImg={dataMethod?.data.direct_debit}
                name="DIRECT DEBIT"
                type="DIRECT_DEBIT"
                icon={
                  <IconCreditCardPay className="w-[22px] h-[22px] text-gray-800" />
                }
                isOpen={openIndex === 3}
                onToggle={() => setOpenIndex(openIndex === 3 ? null : 3)}
                settings={settings}
                setPickPayment={setPickPayment}
                setDataPayment={setDataPayment}
              /> */}

              <CardPaymentMethod
                dataImg={DEFAULT_DATA?.data.qris}
                name="QRIS"
                type="QRIS"
                icon={
                  <IconQrcode className="w-[22px] h-[22px] text-gray-800" />
                }
                isOpen={openIndex === 4}
                onToggle={() => setOpenIndex(openIndex === 4 ? null : 4)}
                settings={settings}
                setPickPayment={setPickPayment}
                setDataPayment={setDataPayment}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Method;
